import React from "react";

const Java_atan = () => {
  return (
    <div>
      <h1>Java atan</h1>
      <p>This page provides explanations, examples, and common use-cases for Java atan in Java.</p>
    </div>
  );
};

export default Java_atan;
